





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { AdminApi } from '@/services/api/api.admin';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { ApiPermissions } from '@/core/security/Permissions';
import { Role } from '@/core/security/Role';
import { UserDetailsViewModel, UserUpdateRolesRequest } from '@/types/apiServerContract';
import { User } from '@/models/user/user.model';

@Component
export default class EditUserRoles extends Vue {
	@Prop({ required: true })
	user!: User;

	@Prop({ required: true })
	userData!: UserDetailsViewModel;

	permissions: string[] = [ApiPermissions.User.UpdateUserRoles];
	roles: Role[] = [];
	userRoles: Role[] = [];
	loading: boolean = false;

	Reset() {
	    this.userRoles = this.userData.user.roles as Role[];
	}

	async UpdateRoles() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to save these changes?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.loading = true;

	    try {
	        const request: UserUpdateRolesRequest = {
	            userId: this.user.id,
	            roles: this.userRoles
	        };
	        await AdminApi.UpdateUserRoles(request);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast(`${this.user.userName}'s roles have been updated for ${RealmsModule.ActiveRealm!.name}`, {
	        variant: 'success',
	        title: 'Success'
	    });
	}

	async created() {
	    const result = await AdminApi.GetRoles();
	    this.roles = result.roles as Role[];

	    this.Reset();
	}
}
